<template>
  <div>
    <!-- participants -->
    <div>
      <div class="card-body border-bottom py-3">
        <div class="row justify-content-between align-items-center">
          <div class="col-auto">
            <h4 class="card-title mb-0">
              Datos de los asistentes
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body bg-light">
        <form @submit.prevent="registerDataUser()">
          <div v-for="(item, idx) in participantsData" :key="idx">
            <h3>
              <span>Datos del asistente: #{{ idx + 1 }}</span>
            </h3>
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="form-group w-100">
                  <div>Tipo documento*</div>
                  <select
                    v-model="item.documentType"
                    class="form-control"
                    required
                  >
                    <option v-for="doc in docTypes" :value="doc" :key="doc">
                      {{ doc }}
                    </option>
                  </select>
                </label>
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-group w-100">
                  <div>N° de documento*</div>
                  <input
                    v-model.trim="item.document"
                    :ref="`doc${idx}`"
                    type="text"
                    class="form-control"
                    :minlength="item.documentType === 'DNI' ? 8 : 5"
                    :maxlength="item.documentType === 'DNI' ? 8 : 15"
                    :class="{'is-invalid': hasInvalidField('document', item)}"
                    required autocomplete="off"
                  >
                </label>
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-group w-100">
                  <div>Nombres*</div>
                  <input
                    v-model.trim="item.name"
                    type="text"
                    class="form-control"
                    minlength="2"
                    required autocomplete="off"
                  >
                </label>
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-group w-100">
                  <div>Apellidos*</div>
                  <input
                    v-model.trim="item.lastName"
                    type="text"
                    class="form-control"
                    minlength="2"
                    required autocomplete="off"
                  >
                </label>
              </div>
              <div class="col-12">
                <b-form-checkbox
                  :id="`checkbox-child-${idx}`"
                  v-model="item.isChild"
                >
                  ¿El asistente es menor de edad?
                </b-form-checkbox>
              </div>
            </div>
            <hr>
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                v-model="terms"
                id="checkbox-terms"
                required
              >
              <label class="custom-control-label" for="checkbox-terms">
                Declaro que todos lo asistentes desde los <b>0 años contarán
                con una entrada</b> para poder ingresar al evento deportivo.
              </label>
            </div>
            <div v-if="!item.status || !item.isAvailable" class="text-danger small mt-2">
              {{ item.message || 'Ya existe un participante con este DNI inscrito en el evento' }}
            </div>
            <hr>
          </div>
          <slot></slot>
          <div class="text-right">
            <button
              class="btn btn-action btn-lg px-5"
              type="submit"
              :disabled="loading"
            >
              <b-spinner v-if="loading" small class="mr-1"></b-spinner>
              Continuar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

const docTypes = ['DNI', 'CE', 'PASS'];

export default {
  props: ['quantity', 'activityId', 'transactionId'],
  data() {
    return {
      docTypes,
      loading: false,
      terms: false,
      participantsData: [],
    };
  },
  created() {
    this.generateParticipants();
  },
  computed: {
    hasParticipants() {
      return this.participantsData.length;
    },
    validateParticipants() {
      const { participantsData: users } = this;
      if (users.length > 0) {
        let valid = true;
        let invalidNom = false;
        users.forEach((el) => {
          if (!el.name || !el.lastName || !el.document) {
            valid = false;
          }
          invalidNom = this.hasInvalidField('document', el);
        });
        return valid && !invalidNom;
      }
      return true;
    },
    validateParticipantsServer() {
      return this.participantsData.every(el => el.status && el.isAvailable);
    },
  },
  watch: {
    quantity: {
      handler() {
        this.generateParticipants();
      },
      inmediate: true,
    },
  },
  methods: {
    generateParticipants() {
      const allArr = [];
      // eslint-disable-next-line
      for (let i = 0; i < this.quantity; i++) {
        // eslint-disable-next-line
        const dataUser = {
          name: '',
          lastName: '',
          documentType: 'DNI',
          document: '',
          isChild: false,
          status: true,
          message: '',
          isAvailable: true,
        };
        const clon = { ...dataUser };
        allArr.push(clon);
      }
      this.participantsData = allArr;
    },
    hasInvalidField(field, item) {
      let counter = 0;
      this.participantsData.forEach((el) => {
        if (el[field] && el[field] === item[field]) {
          counter += 1;
        }
      });
      return counter > 1;
    },
    mergeParticipants(res) {
      res.forEach((el) => {
        const fi = this.participantsData.findIndex(
          item => item.document === el.data.document,
        );
        const user = this.participantsData[fi];
        this.$set(user, 'status', el.status);
        this.$set(user, 'isAvailable', el.data.isAvailable);
        if (!el.status) {
          this.$set(user, 'message', el.message);
        }
      });
    },
    async registerDataUser() {
      if (!this.validateParticipants) return;
      const { participantsData } = this;
      participantsData.map((el) => {
        el.status = true;
        el.message = '';
        el.isAvailable = true;
        el.percent = 45;
        return el;
      });
      this.loading = true;
      const payload = {
        transactionId: this.transactionId,
        activityId: this.activityId,
        participants: participantsData,
      };
      const url = `${api.nodeUrl}/validate-participants`;
      // eslint-disable-next-line
      const { data: { data: res } } = await api.axios.post(url, payload);
      this.loading = false;
      this.mergeParticipants(res);
      if (!this.validateParticipantsServer) return;
      this.$emit('submit', participantsData);
    },
  },
};
</script>
